import src from "IMAGE";
export default { src, width: 1920, height: 694, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAI0lEQVR42n3DoREAAAgCQPZf07Nq8SDiBoRHNZ1gTk6wlJMHkIJbgQ0R08cAAAAASUVORK5CYII="};
